// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `

/* Start All Page */
.all-page-section{
    margin-top: 10px;
    padding-top: 15px;
    padding-bottom: 10px;
    width: 100%;
    height: calc(100vh - 75px);
    overflow-y: scroll;
}

.all-page-section .searh-page-token{
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 700px;
    padding: 10px;
    margin-bottom: 10px;
    max-width: 100%;
}

.all-page-section .searh-page-token .search-bar{
    background-color: white;
    width: 300px;
    display: flex;
    align-items: center;
    padding: 9px 10px;
    border-radius: 22px;
}

.all-page-section .searh-page-token .search-bar input{
    width: calc(100% - 32px);
    border: none;
    color: #737574;
}

.all-page-section .searh-page-token .search-bar input:focus{
    outline: none;
}

.all-page-section .searh-page-token .search-bar svg{
    color:#737574;
    width: 30px;
}

.all-page-section .searh-page-token .btn-group button{
    background-color: #4BB543;
    border: none;
    border-radius: 7px;
    padding: 8px 12px;
    cursor: pointer;
    color: white;
    display: flex;
    justify-content: center;
    align-items: center;
    font-weight: 600;
    font-size: 13px;
    transition: var(--main-transition);
}

.all-page-section .searh-page-token .btn-group button svg{
    padding: 0px 5px;
    font-weight: bold;
}

.all-page-section .searh-page-token .btn-group button:hover{
    background-color: #5bc953;
}

 .k-modal .write-message-con .normal-input{
    width: 100%;
    padding: 10px 13px;
    border: 1px solid #EEE;
    border-radius: 5px;
    margin-top: 3px;
}

.k-modal .write-message-con .normal-input:focus{
    outline: none;
}

/* End All Page */

/* Start Page Card */

.page-card{
    background-color:white;
    display: flex;
    flex-wrap: wrap;
    text-decoration: none;
    align-content: center;
    width: 700px;
    max-width: 100%;
    background-color: white;
    margin-bottom: 18px;
    border-radius: 10px;
    overflow: hidden;
    padding: 0px 0px;
    position: relative;
    height:84px;
}

@media(max-width:600px){
    .page-card{
        max-width: 93%;
    }
}

.page-card .left{
    display: flex;
    align-items: center;
    width: 100%;
    padding: 8px 14px;
}

.page-card .left .page-title-con{
    display: flex;
    align-items: center;
    gap: 10px;
}

.page-card .left .page-title-con p {
    font-size: 15px;
}

.page-card .right {
    color: #737574;
    cursor: pointer;
    background-color: transparent;
    width: 8%;
    height: 100%;
    padding: 0px 7px;
    display: flex;
    justify-content: center;
    align-items: center;
    transition: var(--main-transition);
    overflow: hidden;
    position: relative;
}

.page-card .right::before{
content: "";
width: 100%;
height: 100%;
background-color:#dc3545; 
position: absolute;
top: 0;
transition: var(--main-transition);
right: -100%;

}

.page-card .right svg{
    transition: var(--main-transition);
    z-index: 2;
    
}

.page-card .right:hover::before{
right: 0;

}


.page-card .rr {
    color: #737574;
    cursor: pointer;
    background-color: transparent;
    width: 8%;
    height: 100%;
    padding: 0px 7px;
    display: flex;
    justify-content: center;
    align-items: center;
    transition: var(--main-transition);
    overflow: hidden;
    position: relative;
}

.page-card .rr::before{
content: "";
width: 100%;
height: 100%;
background-color:#dc3545; 
position: absolute;
top: 0;
transition: var(--main-transition);
left: -100%;

}

.page-card .rr:hover::before{
    left: 0;
    
    }

.page-card .right:hover svg{
    color: white;
}

.page-card .rr:hover svg{
    color: white;
}

/* .page-card::before{
    content: "";
    position: absolute;
    width: 100%;
    height: 100%;
    background-color: #EEE;
    left: -100%;
    top: 0;
    transition: var(--main-transition);
    opacity: .4;
} */



.page-card .page-logo
{
    width: 55px;
    height: 55px;margin: 0 10px;

}


.page-card .page-logo img {
    border-radius: 50%;
    width: 55px;
    height: 55px;
}

.page-card .page-id{
    color: var(--gray-color);
}

.page-card h3 {
    color: black;

}

.page-card .page-type{
    color: var(--gray-color);
}
/* End Page Card */


/* Start Post Component */

.all-post-page{
    padding-top: 10px;
    height: calc(100vh - 11px);
    overflow-y: scroll;
    display: flex;
    flex-direction: column;
}

.all-post-page .message-btn{
    background-color: var(--main-color);
    color: white;
    display: block;
    font-weight: bold;
    padding: 10px 22px;
    border-radius: 23px;
    text-decoration: none;
    width: 170px;
    height: 40px;
    text-align: center;
    font-size: 13px;
    display: flex;
    justify-content: center;
    align-items: center;
    margin: 6px 0px;
}

::-webkit-scrollbar {
    width: 0px;
  }

  .all-post-page .post-com{
    width: 600px;
    background-color: white;
    border-radius: 6px;
    padding: 10px 8px;
    margin-bottom:20px ;
  }

    .all-post-page .post-com .post-head{
        display: flex;
        align-items: center;

    }
    .all-post-page .post-com .post-head .image img{
        width: 40px;
        height: 40px;
        border-radius: 50%;
    }

    .all-post-page .post-com .post-head .info{
        display: flex;
        flex-direction: column;
        margin:0px 8px;
        
    }

    .all-post-page .post-com .post-head .info h3 ,
    .all-post-page .post-com .post-head .info p {
        padding: 0;
        margin: 0;
    }
    .all-post-page .post-com .post-head .info h3{
        font-size: 16px;

    }

    .all-post-page .post-com .post-head .info .date{
        color: var(--gray-color);
        font-size: 13px;
        margin-top: -6px;
    }

    .all-post-page .post-com .post-body{
        width: 100%;
        
        
    }

    .all-post-page .post-com .post-comment{
        padding: 0px 5px;
        margin: 10px 0px;
    }

    .all-post-page .post-com .post-comment .comment-btn{
        background-color: var(--main-color);
        width: 100%;
        font-weight: bold;
        padding: 10px 0px;
        border-radius: 7px;
        border: none;
        color: white;
        cursor: pointer;
    }

    .all-post-page .post-com .post-image{
    margin: 10px 0px;
    }

    .all-post-page .post-com .post-image img {
        width: 100%;
        max-width: 100%;
        object-fit:contain;
        height: 400px;
        border-radius: 5px;
    }

    .all-post-page .search-bar{
        width: 600px;
        margin-bottom: 10px;
        /* border: 1px solid #EEE; */
        border-radius: 6px;
        padding: 10px 10px;
        display: flex;
        background-color: white;
        align-items: center;
    }

    .all-post-page .search-bar input{
        border: none;
        background-color: transparent;
        width: calc(100% - 18px);
    }

    .all-post-page .search-bar input::placeholder{
        color: var(--gray-color);
    }

    .all-post-page .search-bar input:focus{
        outline: none;
    }

    .all-post-page .search-bar svg{
        color: var(--gray-color);
        margin:0px 6px;
        width: 18px;
    }

    .all-post-page .search-btn {
        background-color: var(--main-color);
        border: none;
        width: 120px;
        border-radius: 22px;
        margin-left: -28px;
        color: white;
        cursor: pointer;
        font-weight: bold;
        height: 36px;
        transition: var(--main-transition);
    }

    .all-post-page .search-btn:hover{
        background-color: #0876f5;
    }


/* End Post Component */
.all-comment-page
{
    /* margin-top: 20px; */
    width: 100%;
    height: calc(100vh - 78px);
    overflow-y: scroll;
}
.all-comment-page .search-bar{
    margin-top: 12px;
    width: 350px;
    background-color: white;
    border-radius: 12px;
    padding: 5px 10px;
}

@media(max-width:550px){
    .all-comment-page .search-bar{
        width: 250px;

    }
}

.all-comment-page .search-bar svg{
    color: var(--gray-color);
    margin: 0 8px;
    width: 17px;
}

.all-comment-page .search-bar input{
    border: none;
    width: calc(100% - 50px);

}

.all-comment-page .search-bar input::placeholder{
    color: var(--gray-color);
}

.all-comment-page .search-bar input:focus{
    outline: none;
}

.all-comment-page  .all-co{
    width: 1020px;
    max-width: 100%;
    margin-top: 10px;
    padding-bottom: 20px ;
}

@media(max-width:550px){
    .all-comment-page  .all-co{
        height: 77vh !important;
        overflow-y: scroll !important;
    }
}

.all-comment-page  .all-co .comment-item-head{
    background-color: white;
    padding: 8px 15px; 
    display: flex;
    align-items: center;
    border-radius: 6px;
    margin-bottom: 10px;
}

.all-comment-page  .all-co .comment-item-body{
    background-color: white;
    padding: 8px 15px; 
    display: flex;
    align-items: center;
    border-radius: 6px;
    margin-bottom: 4px;
}


.all-comment-page  .all-co .item-check{
    width: 27px;
    
}

.all-comment-page  .all-co .item-check input {
    cursor: pointer;
}
  
.all-comment-page  .all-co .item-comment_id{
    width: 180px;
    text-align: center;
    cursor: pointer;
    font-weight:bold;
}


.all-comment-page  .all-co .item-comment_user{
    width: 150px;
    text-align: center;
    font-weight:bold;
    cursor: pointer;
}

.all-comment-page  .all-co .item-content{
    width: 300px;
    text-align: center;
    font-weight:bold;
    cursor: pointer;
}

.all-comment-page  .all-co .item-os{
    width: 170px;
    text-align: center;
    font-weight:bold;
    cursor:pointer;

}


.all-comment-page  .all-co .item-info-user{
    width: 130px;
    text-align: center;
    cursor: pointer;
    font-weight:bold;
}


.all-comment-page  .all-co .nor{
    font-weight: normal;
}
.all-comment-page  .all-co .nor input {
    cursor: pointer;
}

.all-comment-page .tools-filter
{
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 1020px;
    max-width: 100%;
    margin-bottom: 15px;
    flex-wrap: wrap;
}
.all-comment-page .tools-filter .btn-group{
    display: flex;
    align-items: center;
}
@media(max-width : 600px){
    .all-comment-page .tools-filter .btn-group{
        margin-top: 10px;
    }
}

.all-comment-page .tools-filter .btn-group button{
    border: none;
    padding: 11px 20px;
    border-radius: 6px;
    margin: 0px 6px;
    color: white;
    cursor: pointer;
    font-weight: bold;
    transition:var(--main-transition);
}

.all-comment-page .tools-filter .btn-group span {
    width: 30px;
    height: 30px;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 50%;
    cursor: pointer;margin: 0px 5px;
    transition: var(--main-transition);
}
.all-comment-page .tools-filter .btn-group span:hover{
    background-color: #dedddd;
}

.all-comment-page .tools-filter .btn-group span svg{
color: gray;
}

.all-comment-page .tools-filter .btn-group button:hover{
    opacity: .9;
}

.all-comment-page .tools-filter .btn-group .btn-message{
    background-color: var(--message-btn);
}

.all-comment-page .tools-filter .btn-group .btn-replay{
    background-color:#005fcc ;
}

.all-comment-page .tools-filter .btn-group button svg{
    margin:0px 5px;
}

.all-comment-page .tools-filter .os-drop-menu{
    background-color: white;
    border-radius: 12px;
    width: 130px;
    padding: 5px 10px;
    position: relative;
    border: 1px solid #efeeee;
    text-align: center;
    margin: 0px 10px;
    margin-top: 12px;
    cursor: pointer;
}

@media(max-width:550px){
    .all-comment-page .tools-filter .os-drop-menu{
        width: 110px;

    }
}

.all-comment-page .tools-filter .os-drop-menu  p svg{
    font-size: 13px;
    margin:0px 1px ;
}

.all-comment-page .tools-filter .os-drop-menu  p{
    font-size: 14px;
    font-weight: 600;
}

.all-comment-page .tools-filter .os-drop-menu .type-os-dropdown
{
    position: absolute;
    list-style: none;
    background-color: white;
    width: 200px;
    padding: 3px 6px;
    top: 120%;
    left: 0;
    border-radius: 7px;
    border: 1px solid #EEE;
    box-shadow: 1px 1px 1px #EEE ;
}

.all-comment-page .tools-filter .os-drop-menu  .en{
    left: 0;
}

.all-comment-page .tools-filter .os-drop-menu  .ar{
    right: 0;
}

.all-comment-page .tools-filter .os-drop-menu .type-os-dropdown-active{

    opacity: 1;
    visibility: visible;
    transform: translateY(0px);
    transition: var(--main-transition) ease;
}
.all-comment-page .tools-filter .os-drop-menu .type-os-dropdown-inactive{

    opacity: 0 ;
    visibility: hidden ;
    transform: translateY(-20px)  ;
    transition: var(--main-transition) ease ;
}



.all-comment-page .tools-filter .os-drop-menu .type-os-dropdown li{
    margin-bottom: 10px;
    transition: var(--main-transition);
    border-radius: 4px;
    padding: 5px 0px;
}

.all-comment-page .tools-filter .os-drop-menu .type-os-dropdown li:hover{
    background-color: #eee;
    padding-left: 4px;

}



/* Start Comment */


/* Start Loadding Component */
    .post-loadding{
    width: 595px;
    max-width: 100%;
    background-color: white;
    height: 230px ;
    border-radius: 8px;
    padding: 10px 8px;
    margin: 10px 0px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
}

.post-loadding .loadding-head{
    display: flex;
    
}


/* For Global Media */
@media(max-width:550px){
    .hide-mobile
    {
        display: none;
    }
}

/* End Loadding Component */`, "",{"version":3,"sources":["webpack://./src/Pages/Page/Page.css"],"names":[],"mappings":";;AAEA,mBAAmB;AACnB;IACI,gBAAgB;IAChB,iBAAiB;IACjB,oBAAoB;IACpB,WAAW;IACX,0BAA0B;IAC1B,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,eAAe;AACnB;;AAEA;IACI,uBAAuB;IACvB,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,iBAAiB;IACjB,mBAAmB;AACvB;;AAEA;IACI,wBAAwB;IACxB,YAAY;IACZ,cAAc;AAClB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,aAAa;IACb,WAAW;AACf;;AAEA;IACI,yBAAyB;IACzB,YAAY;IACZ,kBAAkB;IAClB,iBAAiB;IACjB,eAAe;IACf,YAAY;IACZ,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,gBAAgB;IAChB,eAAe;IACf,kCAAkC;AACtC;;AAEA;IACI,gBAAgB;IAChB,iBAAiB;AACrB;;AAEA;IACI,yBAAyB;AAC7B;;CAEC;IACG,WAAW;IACX,kBAAkB;IAClB,sBAAsB;IACtB,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,aAAa;AACjB;;AAEA,iBAAiB;;AAEjB,oBAAoB;;AAEpB;IACI,sBAAsB;IACtB,aAAa;IACb,eAAe;IACf,qBAAqB;IACrB,qBAAqB;IACrB,YAAY;IACZ,eAAe;IACf,uBAAuB;IACvB,mBAAmB;IACnB,mBAAmB;IACnB,gBAAgB;IAChB,gBAAgB;IAChB,kBAAkB;IAClB,WAAW;AACf;;AAEA;IACI;QACI,cAAc;IAClB;AACJ;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,WAAW;IACX,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;AACb;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,cAAc;IACd,eAAe;IACf,6BAA6B;IAC7B,SAAS;IACT,YAAY;IACZ,gBAAgB;IAChB,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,kCAAkC;IAClC,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;AACA,WAAW;AACX,WAAW;AACX,YAAY;AACZ,wBAAwB;AACxB,kBAAkB;AAClB,MAAM;AACN,kCAAkC;AAClC,YAAY;;AAEZ;;AAEA;IACI,kCAAkC;IAClC,UAAU;;AAEd;;AAEA;AACA,QAAQ;;AAER;;;AAGA;IACI,cAAc;IACd,eAAe;IACf,6BAA6B;IAC7B,SAAS;IACT,YAAY;IACZ,gBAAgB;IAChB,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,kCAAkC;IAClC,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;AACA,WAAW;AACX,WAAW;AACX,YAAY;AACZ,wBAAwB;AACxB,kBAAkB;AAClB,MAAM;AACN,kCAAkC;AAClC,WAAW;;AAEX;;AAEA;IACI,OAAO;;IAEP;;AAEJ;IACI,YAAY;AAChB;;AAEA;IACI,YAAY;AAChB;;AAEA;;;;;;;;;;GAUG;;;;AAIH;;IAEI,WAAW;IACX,YAAY,CAAC,cAAc;;AAE/B;;;AAGA;IACI,kBAAkB;IAClB,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,YAAY;;AAEhB;;AAEA;IACI,wBAAwB;AAC5B;AACA,kBAAkB;;;AAGlB,yBAAyB;;AAEzB;IACI,iBAAiB;IACjB,0BAA0B;IAC1B,kBAAkB;IAClB,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,mCAAmC;IACnC,YAAY;IACZ,cAAc;IACd,iBAAiB;IACjB,kBAAkB;IAClB,mBAAmB;IACnB,qBAAqB;IACrB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,eAAe;AACnB;;AAEA;IACI,UAAU;EACZ;;EAEA;IACE,YAAY;IACZ,uBAAuB;IACvB,kBAAkB;IAClB,iBAAiB;IACjB,mBAAmB;EACrB;;IAEE;QACI,aAAa;QACb,mBAAmB;;IAEvB;IACA;QACI,WAAW;QACX,YAAY;QACZ,kBAAkB;IACtB;;IAEA;QACI,aAAa;QACb,sBAAsB;QACtB,cAAc;;IAElB;;IAEA;;QAEI,UAAU;QACV,SAAS;IACb;IACA;QACI,eAAe;;IAEnB;;IAEA;QACI,wBAAwB;QACxB,eAAe;QACf,gBAAgB;IACpB;;IAEA;QACI,WAAW;;;IAGf;;IAEA;QACI,gBAAgB;QAChB,gBAAgB;IACpB;;IAEA;QACI,mCAAmC;QACnC,WAAW;QACX,iBAAiB;QACjB,iBAAiB;QACjB,kBAAkB;QAClB,YAAY;QACZ,YAAY;QACZ,eAAe;IACnB;;IAEA;IACA,gBAAgB;IAChB;;IAEA;QACI,WAAW;QACX,eAAe;QACf,kBAAkB;QAClB,aAAa;QACb,kBAAkB;IACtB;;IAEA;QACI,YAAY;QACZ,mBAAmB;QACnB,4BAA4B;QAC5B,kBAAkB;QAClB,kBAAkB;QAClB,aAAa;QACb,uBAAuB;QACvB,mBAAmB;IACvB;;IAEA;QACI,YAAY;QACZ,6BAA6B;QAC7B,wBAAwB;IAC5B;;IAEA;QACI,wBAAwB;IAC5B;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,wBAAwB;QACxB,cAAc;QACd,WAAW;IACf;;IAEA;QACI,mCAAmC;QACnC,YAAY;QACZ,YAAY;QACZ,mBAAmB;QACnB,kBAAkB;QAClB,YAAY;QACZ,eAAe;QACf,iBAAiB;QACjB,YAAY;QACZ,kCAAkC;IACtC;;IAEA;QACI,yBAAyB;IAC7B;;;AAGJ,uBAAuB;AACvB;;IAEI,sBAAsB;IACtB,WAAW;IACX,0BAA0B;IAC1B,kBAAkB;AACtB;AACA;IACI,gBAAgB;IAChB,YAAY;IACZ,uBAAuB;IACvB,mBAAmB;IACnB,iBAAiB;AACrB;;AAEA;IACI;QACI,YAAY;;IAEhB;AACJ;;AAEA;IACI,wBAAwB;IACxB,aAAa;IACb,WAAW;AACf;;AAEA;IACI,YAAY;IACZ,wBAAwB;;AAE5B;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,aAAa;IACb,eAAe;IACf,gBAAgB;IAChB,qBAAqB;AACzB;;AAEA;IACI;QACI,uBAAuB;QACvB,6BAA6B;IACjC;AACJ;;AAEA;IACI,uBAAuB;IACvB,iBAAiB;IACjB,aAAa;IACb,mBAAmB;IACnB,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI,uBAAuB;IACvB,iBAAiB;IACjB,aAAa;IACb,mBAAmB;IACnB,kBAAkB;IAClB,kBAAkB;AACtB;;;AAGA;IACI,WAAW;;AAEf;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,gBAAgB;AACpB;;;AAGA;IACI,YAAY;IACZ,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,YAAY;IACZ,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,YAAY;IACZ,kBAAkB;IAClB,gBAAgB;IAChB,cAAc;;AAElB;;;AAGA;IACI,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,gBAAgB;AACpB;;;AAGA;IACI,mBAAmB;AACvB;AACA;IACI,eAAe;AACnB;;AAEA;;IAEI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,aAAa;IACb,eAAe;IACf,mBAAmB;IACnB,eAAe;AACnB;AACA;IACI,aAAa;IACb,mBAAmB;AACvB;AACA;IACI;QACI,gBAAgB;IACpB;AACJ;;AAEA;IACI,YAAY;IACZ,kBAAkB;IAClB,kBAAkB;IAClB,eAAe;IACf,YAAY;IACZ,eAAe;IACf,iBAAiB;IACjB,iCAAiC;AACrC;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,kBAAkB;IAClB,eAAe,CAAC,eAAe;IAC/B,kCAAkC;AACtC;AACA;IACI,yBAAyB;AAC7B;;AAEA;AACA,WAAW;AACX;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,oCAAoC;AACxC;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,uBAAuB;IACvB,mBAAmB;IACnB,YAAY;IACZ,iBAAiB;IACjB,kBAAkB;IAClB,yBAAyB;IACzB,kBAAkB;IAClB,gBAAgB;IAChB,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI;QACI,YAAY;;IAEhB;AACJ;;AAEA;IACI,eAAe;IACf,eAAe;AACnB;;AAEA;IACI,eAAe;IACf,gBAAgB;AACpB;;AAEA;;IAEI,kBAAkB;IAClB,gBAAgB;IAChB,uBAAuB;IACvB,YAAY;IACZ,gBAAgB;IAChB,SAAS;IACT,OAAO;IACP,kBAAkB;IAClB,sBAAsB;IACtB,6BAA6B;AACjC;;AAEA;IACI,OAAO;AACX;;AAEA;IACI,QAAQ;AACZ;;AAEA;;IAEI,UAAU;IACV,mBAAmB;IACnB,0BAA0B;IAC1B,uCAAuC;AAC3C;AACA;;IAEI,WAAW;IACX,mBAAmB;IACnB,8BAA8B;IAC9B,wCAAwC;AAC5C;;;;AAIA;IACI,mBAAmB;IACnB,kCAAkC;IAClC,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,sBAAsB;IACtB,iBAAiB;;AAErB;;;;AAIA,kBAAkB;;;AAGlB,6BAA6B;IACzB;IACA,YAAY;IACZ,eAAe;IACf,uBAAuB;IACvB,cAAc;IACd,kBAAkB;IAClB,iBAAiB;IACjB,gBAAgB;IAChB,aAAa;IACb,sBAAsB;IACtB,8BAA8B;AAClC;;AAEA;IACI,aAAa;;AAEjB;;;AAGA,qBAAqB;AACrB;IACI;;QAEI,aAAa;IACjB;AACJ;;AAEA,2BAA2B","sourcesContent":["\n\n/* Start All Page */\n.all-page-section{\n    margin-top: 10px;\n    padding-top: 15px;\n    padding-bottom: 10px;\n    width: 100%;\n    height: calc(100vh - 75px);\n    overflow-y: scroll;\n}\n\n.all-page-section .searh-page-token{\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    width: 700px;\n    padding: 10px;\n    margin-bottom: 10px;\n    max-width: 100%;\n}\n\n.all-page-section .searh-page-token .search-bar{\n    background-color: white;\n    width: 300px;\n    display: flex;\n    align-items: center;\n    padding: 9px 10px;\n    border-radius: 22px;\n}\n\n.all-page-section .searh-page-token .search-bar input{\n    width: calc(100% - 32px);\n    border: none;\n    color: #737574;\n}\n\n.all-page-section .searh-page-token .search-bar input:focus{\n    outline: none;\n}\n\n.all-page-section .searh-page-token .search-bar svg{\n    color:#737574;\n    width: 30px;\n}\n\n.all-page-section .searh-page-token .btn-group button{\n    background-color: #4BB543;\n    border: none;\n    border-radius: 7px;\n    padding: 8px 12px;\n    cursor: pointer;\n    color: white;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    font-weight: 600;\n    font-size: 13px;\n    transition: var(--main-transition);\n}\n\n.all-page-section .searh-page-token .btn-group button svg{\n    padding: 0px 5px;\n    font-weight: bold;\n}\n\n.all-page-section .searh-page-token .btn-group button:hover{\n    background-color: #5bc953;\n}\n\n .k-modal .write-message-con .normal-input{\n    width: 100%;\n    padding: 10px 13px;\n    border: 1px solid #EEE;\n    border-radius: 5px;\n    margin-top: 3px;\n}\n\n.k-modal .write-message-con .normal-input:focus{\n    outline: none;\n}\n\n/* End All Page */\n\n/* Start Page Card */\n\n.page-card{\n    background-color:white;\n    display: flex;\n    flex-wrap: wrap;\n    text-decoration: none;\n    align-content: center;\n    width: 700px;\n    max-width: 100%;\n    background-color: white;\n    margin-bottom: 18px;\n    border-radius: 10px;\n    overflow: hidden;\n    padding: 0px 0px;\n    position: relative;\n    height:84px;\n}\n\n@media(max-width:600px){\n    .page-card{\n        max-width: 93%;\n    }\n}\n\n.page-card .left{\n    display: flex;\n    align-items: center;\n    width: 100%;\n    padding: 8px 14px;\n}\n\n.page-card .left .page-title-con{\n    display: flex;\n    align-items: center;\n    gap: 10px;\n}\n\n.page-card .left .page-title-con p {\n    font-size: 15px;\n}\n\n.page-card .right {\n    color: #737574;\n    cursor: pointer;\n    background-color: transparent;\n    width: 8%;\n    height: 100%;\n    padding: 0px 7px;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    transition: var(--main-transition);\n    overflow: hidden;\n    position: relative;\n}\n\n.page-card .right::before{\ncontent: \"\";\nwidth: 100%;\nheight: 100%;\nbackground-color:#dc3545; \nposition: absolute;\ntop: 0;\ntransition: var(--main-transition);\nright: -100%;\n\n}\n\n.page-card .right svg{\n    transition: var(--main-transition);\n    z-index: 2;\n    \n}\n\n.page-card .right:hover::before{\nright: 0;\n\n}\n\n\n.page-card .rr {\n    color: #737574;\n    cursor: pointer;\n    background-color: transparent;\n    width: 8%;\n    height: 100%;\n    padding: 0px 7px;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    transition: var(--main-transition);\n    overflow: hidden;\n    position: relative;\n}\n\n.page-card .rr::before{\ncontent: \"\";\nwidth: 100%;\nheight: 100%;\nbackground-color:#dc3545; \nposition: absolute;\ntop: 0;\ntransition: var(--main-transition);\nleft: -100%;\n\n}\n\n.page-card .rr:hover::before{\n    left: 0;\n    \n    }\n\n.page-card .right:hover svg{\n    color: white;\n}\n\n.page-card .rr:hover svg{\n    color: white;\n}\n\n/* .page-card::before{\n    content: \"\";\n    position: absolute;\n    width: 100%;\n    height: 100%;\n    background-color: #EEE;\n    left: -100%;\n    top: 0;\n    transition: var(--main-transition);\n    opacity: .4;\n} */\n\n\n\n.page-card .page-logo\n{\n    width: 55px;\n    height: 55px;margin: 0 10px;\n\n}\n\n\n.page-card .page-logo img {\n    border-radius: 50%;\n    width: 55px;\n    height: 55px;\n}\n\n.page-card .page-id{\n    color: var(--gray-color);\n}\n\n.page-card h3 {\n    color: black;\n\n}\n\n.page-card .page-type{\n    color: var(--gray-color);\n}\n/* End Page Card */\n\n\n/* Start Post Component */\n\n.all-post-page{\n    padding-top: 10px;\n    height: calc(100vh - 11px);\n    overflow-y: scroll;\n    display: flex;\n    flex-direction: column;\n}\n\n.all-post-page .message-btn{\n    background-color: var(--main-color);\n    color: white;\n    display: block;\n    font-weight: bold;\n    padding: 10px 22px;\n    border-radius: 23px;\n    text-decoration: none;\n    width: 170px;\n    height: 40px;\n    text-align: center;\n    font-size: 13px;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    margin: 6px 0px;\n}\n\n::-webkit-scrollbar {\n    width: 0px;\n  }\n\n  .all-post-page .post-com{\n    width: 600px;\n    background-color: white;\n    border-radius: 6px;\n    padding: 10px 8px;\n    margin-bottom:20px ;\n  }\n\n    .all-post-page .post-com .post-head{\n        display: flex;\n        align-items: center;\n\n    }\n    .all-post-page .post-com .post-head .image img{\n        width: 40px;\n        height: 40px;\n        border-radius: 50%;\n    }\n\n    .all-post-page .post-com .post-head .info{\n        display: flex;\n        flex-direction: column;\n        margin:0px 8px;\n        \n    }\n\n    .all-post-page .post-com .post-head .info h3 ,\n    .all-post-page .post-com .post-head .info p {\n        padding: 0;\n        margin: 0;\n    }\n    .all-post-page .post-com .post-head .info h3{\n        font-size: 16px;\n\n    }\n\n    .all-post-page .post-com .post-head .info .date{\n        color: var(--gray-color);\n        font-size: 13px;\n        margin-top: -6px;\n    }\n\n    .all-post-page .post-com .post-body{\n        width: 100%;\n        \n        \n    }\n\n    .all-post-page .post-com .post-comment{\n        padding: 0px 5px;\n        margin: 10px 0px;\n    }\n\n    .all-post-page .post-com .post-comment .comment-btn{\n        background-color: var(--main-color);\n        width: 100%;\n        font-weight: bold;\n        padding: 10px 0px;\n        border-radius: 7px;\n        border: none;\n        color: white;\n        cursor: pointer;\n    }\n\n    .all-post-page .post-com .post-image{\n    margin: 10px 0px;\n    }\n\n    .all-post-page .post-com .post-image img {\n        width: 100%;\n        max-width: 100%;\n        object-fit:contain;\n        height: 400px;\n        border-radius: 5px;\n    }\n\n    .all-post-page .search-bar{\n        width: 600px;\n        margin-bottom: 10px;\n        /* border: 1px solid #EEE; */\n        border-radius: 6px;\n        padding: 10px 10px;\n        display: flex;\n        background-color: white;\n        align-items: center;\n    }\n\n    .all-post-page .search-bar input{\n        border: none;\n        background-color: transparent;\n        width: calc(100% - 18px);\n    }\n\n    .all-post-page .search-bar input::placeholder{\n        color: var(--gray-color);\n    }\n\n    .all-post-page .search-bar input:focus{\n        outline: none;\n    }\n\n    .all-post-page .search-bar svg{\n        color: var(--gray-color);\n        margin:0px 6px;\n        width: 18px;\n    }\n\n    .all-post-page .search-btn {\n        background-color: var(--main-color);\n        border: none;\n        width: 120px;\n        border-radius: 22px;\n        margin-left: -28px;\n        color: white;\n        cursor: pointer;\n        font-weight: bold;\n        height: 36px;\n        transition: var(--main-transition);\n    }\n\n    .all-post-page .search-btn:hover{\n        background-color: #0876f5;\n    }\n\n\n/* End Post Component */\n.all-comment-page\n{\n    /* margin-top: 20px; */\n    width: 100%;\n    height: calc(100vh - 78px);\n    overflow-y: scroll;\n}\n.all-comment-page .search-bar{\n    margin-top: 12px;\n    width: 350px;\n    background-color: white;\n    border-radius: 12px;\n    padding: 5px 10px;\n}\n\n@media(max-width:550px){\n    .all-comment-page .search-bar{\n        width: 250px;\n\n    }\n}\n\n.all-comment-page .search-bar svg{\n    color: var(--gray-color);\n    margin: 0 8px;\n    width: 17px;\n}\n\n.all-comment-page .search-bar input{\n    border: none;\n    width: calc(100% - 50px);\n\n}\n\n.all-comment-page .search-bar input::placeholder{\n    color: var(--gray-color);\n}\n\n.all-comment-page .search-bar input:focus{\n    outline: none;\n}\n\n.all-comment-page  .all-co{\n    width: 1020px;\n    max-width: 100%;\n    margin-top: 10px;\n    padding-bottom: 20px ;\n}\n\n@media(max-width:550px){\n    .all-comment-page  .all-co{\n        height: 77vh !important;\n        overflow-y: scroll !important;\n    }\n}\n\n.all-comment-page  .all-co .comment-item-head{\n    background-color: white;\n    padding: 8px 15px; \n    display: flex;\n    align-items: center;\n    border-radius: 6px;\n    margin-bottom: 10px;\n}\n\n.all-comment-page  .all-co .comment-item-body{\n    background-color: white;\n    padding: 8px 15px; \n    display: flex;\n    align-items: center;\n    border-radius: 6px;\n    margin-bottom: 4px;\n}\n\n\n.all-comment-page  .all-co .item-check{\n    width: 27px;\n    \n}\n\n.all-comment-page  .all-co .item-check input {\n    cursor: pointer;\n}\n  \n.all-comment-page  .all-co .item-comment_id{\n    width: 180px;\n    text-align: center;\n    cursor: pointer;\n    font-weight:bold;\n}\n\n\n.all-comment-page  .all-co .item-comment_user{\n    width: 150px;\n    text-align: center;\n    font-weight:bold;\n    cursor: pointer;\n}\n\n.all-comment-page  .all-co .item-content{\n    width: 300px;\n    text-align: center;\n    font-weight:bold;\n    cursor: pointer;\n}\n\n.all-comment-page  .all-co .item-os{\n    width: 170px;\n    text-align: center;\n    font-weight:bold;\n    cursor:pointer;\n\n}\n\n\n.all-comment-page  .all-co .item-info-user{\n    width: 130px;\n    text-align: center;\n    cursor: pointer;\n    font-weight:bold;\n}\n\n\n.all-comment-page  .all-co .nor{\n    font-weight: normal;\n}\n.all-comment-page  .all-co .nor input {\n    cursor: pointer;\n}\n\n.all-comment-page .tools-filter\n{\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    width: 1020px;\n    max-width: 100%;\n    margin-bottom: 15px;\n    flex-wrap: wrap;\n}\n.all-comment-page .tools-filter .btn-group{\n    display: flex;\n    align-items: center;\n}\n@media(max-width : 600px){\n    .all-comment-page .tools-filter .btn-group{\n        margin-top: 10px;\n    }\n}\n\n.all-comment-page .tools-filter .btn-group button{\n    border: none;\n    padding: 11px 20px;\n    border-radius: 6px;\n    margin: 0px 6px;\n    color: white;\n    cursor: pointer;\n    font-weight: bold;\n    transition:var(--main-transition);\n}\n\n.all-comment-page .tools-filter .btn-group span {\n    width: 30px;\n    height: 30px;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    border-radius: 50%;\n    cursor: pointer;margin: 0px 5px;\n    transition: var(--main-transition);\n}\n.all-comment-page .tools-filter .btn-group span:hover{\n    background-color: #dedddd;\n}\n\n.all-comment-page .tools-filter .btn-group span svg{\ncolor: gray;\n}\n\n.all-comment-page .tools-filter .btn-group button:hover{\n    opacity: .9;\n}\n\n.all-comment-page .tools-filter .btn-group .btn-message{\n    background-color: var(--message-btn);\n}\n\n.all-comment-page .tools-filter .btn-group .btn-replay{\n    background-color:#005fcc ;\n}\n\n.all-comment-page .tools-filter .btn-group button svg{\n    margin:0px 5px;\n}\n\n.all-comment-page .tools-filter .os-drop-menu{\n    background-color: white;\n    border-radius: 12px;\n    width: 130px;\n    padding: 5px 10px;\n    position: relative;\n    border: 1px solid #efeeee;\n    text-align: center;\n    margin: 0px 10px;\n    margin-top: 12px;\n    cursor: pointer;\n}\n\n@media(max-width:550px){\n    .all-comment-page .tools-filter .os-drop-menu{\n        width: 110px;\n\n    }\n}\n\n.all-comment-page .tools-filter .os-drop-menu  p svg{\n    font-size: 13px;\n    margin:0px 1px ;\n}\n\n.all-comment-page .tools-filter .os-drop-menu  p{\n    font-size: 14px;\n    font-weight: 600;\n}\n\n.all-comment-page .tools-filter .os-drop-menu .type-os-dropdown\n{\n    position: absolute;\n    list-style: none;\n    background-color: white;\n    width: 200px;\n    padding: 3px 6px;\n    top: 120%;\n    left: 0;\n    border-radius: 7px;\n    border: 1px solid #EEE;\n    box-shadow: 1px 1px 1px #EEE ;\n}\n\n.all-comment-page .tools-filter .os-drop-menu  .en{\n    left: 0;\n}\n\n.all-comment-page .tools-filter .os-drop-menu  .ar{\n    right: 0;\n}\n\n.all-comment-page .tools-filter .os-drop-menu .type-os-dropdown-active{\n\n    opacity: 1;\n    visibility: visible;\n    transform: translateY(0px);\n    transition: var(--main-transition) ease;\n}\n.all-comment-page .tools-filter .os-drop-menu .type-os-dropdown-inactive{\n\n    opacity: 0 ;\n    visibility: hidden ;\n    transform: translateY(-20px)  ;\n    transition: var(--main-transition) ease ;\n}\n\n\n\n.all-comment-page .tools-filter .os-drop-menu .type-os-dropdown li{\n    margin-bottom: 10px;\n    transition: var(--main-transition);\n    border-radius: 4px;\n    padding: 5px 0px;\n}\n\n.all-comment-page .tools-filter .os-drop-menu .type-os-dropdown li:hover{\n    background-color: #eee;\n    padding-left: 4px;\n\n}\n\n\n\n/* Start Comment */\n\n\n/* Start Loadding Component */\n    .post-loadding{\n    width: 595px;\n    max-width: 100%;\n    background-color: white;\n    height: 230px ;\n    border-radius: 8px;\n    padding: 10px 8px;\n    margin: 10px 0px;\n    display: flex;\n    flex-direction: column;\n    justify-content: space-between;\n}\n\n.post-loadding .loadding-head{\n    display: flex;\n    \n}\n\n\n/* For Global Media */\n@media(max-width:550px){\n    .hide-mobile\n    {\n        display: none;\n    }\n}\n\n/* End Loadding Component */"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
